import { LiaElement } from '@liasoft/lit-ui';
import { html, nothing } from 'lit';
import { PROFILE_PATH, accountPath } from '../accounts.js';
import { getAccounts } from '../state/context.js';
import '../ui/create-team.js';

/**
 * What a developer with no team beyond their own sees.
 *
 * One page and no tables, because there is nothing to tabulate. It says what personal use is - which is
 * what this person has, and is often all they want - and offers the one thing that changes it: creating
 * a team, where seats are bought and members invited. A colleague's team is reached by invitation,
 * which is theirs to send.
 */
export class UserWelcome extends LiaElement
{
   render()
   {
      const personal = getAccounts().find(entry => entry.personal) ?? null;

      return html`
         <lia-page title="Welcome to covdbg" icon="fa-solid fa-hand" description="You are signed in, and part of no team yet.">
            <div class="row g-3">
               <div class="col-lg-6">
                  <lia-card title="Personal use" icon="fa-solid fa-user" variant="primary">
                     <p>
                        Public repositories are free, without limit and wherever they live. Private ones
                        are one at a time: the first private repository you run covdbg in becomes yours
                        until you release it from your profile, and a seat in a team lifts that.
                     </p>
                     <div class="d-flex flex-wrap gap-2">
                        ${personal
                           ? html`
                              <a class="btn btn-outline-primary btn-sm" href=${accountPath('overview', personal.id)}>
                                 <i class="fa-solid fa-user me-2" aria-hidden="true"></i>Your personal team
                              </a>`
                           : nothing}
                        <a class="btn btn-outline-secondary btn-sm" href=${PROFILE_PATH}>
                           <i class="fa-solid fa-lock me-2" aria-hidden="true"></i>Your profile and lock
                        </a>
                     </div>
                  </lia-card>
                  <lia-card class="mt-3" title="Already on a team?" icon="fa-solid fa-envelope-open">
                     <p class="mb-0">
                        Ask an owner for an invitation. Accepting it puts you in a seat, and every
                        repository is covered from then on.
                     </p>
                  </lia-card>
               </div>
               <div class="col-lg-6">
                  <user-create-team></user-create-team>
               </div>
            </div>
         </lia-page>`;
   }
}

customElements.define('user-welcome', UserWelcome);
